module.exports = __webpack_public_path__ + "static/media/mic_icon.c9bc36e5.svg";